var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99805 0C4.58658 0 0.998047 3.58853 0.998047 8C0.998047 12.4115 4.58658 16 8.99805 16C13.4095 16 16.998 12.4108 16.998 8C16.998 3.58916 13.4095 0 8.99805 0ZM8.99805 14.7607C5.2707 14.7607 2.23739 11.728 2.23739 8C2.23739 4.27203 5.2707 1.23934 8.99805 1.23934C12.726 1.23934 15.7587 4.27203 15.7587 8C15.7587 11.728 12.7254 14.7607 8.99805 14.7607Z",
    fill: "#17B67C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6698 5.2173C12.4176 4.98802 12.0254 5.00599 11.7949 5.25942L8.01483 9.4218L6.18864 7.56527C5.94758 7.32111 5.55595 7.31739 5.31242 7.55783C5.06826 7.79764 5.06454 8.18989 5.30498 8.43405L7.59095 10.7578C7.70808 10.8768 7.8667 10.9431 8.03277 10.9431C8.03649 10.9431 8.04083 10.9431 8.04455 10.9437C8.21558 10.94 8.37671 10.8669 8.49133 10.7405L12.7119 6.09292C12.9419 5.83883 12.9233 5.4472 12.6698 5.2173Z",
    fill: "#17B67C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.998047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7c24b04c86e2de33248c57e491fcabe6.svg";
export { ForwardRef as ReactComponent };